import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string().required("District name is required!"),
  is_active: Yup.string().required("Status is required!"),
});
